import { useLayoutEffect, useRef, type RefObject } from "react";

export const useResizeObserver = <T extends Element>(
  target: RefObject<T | null>,
  onResize: (entry: ResizeObserverEntry) => void,
) => {
  const callbackRef = useRef(onResize);

  useLayoutEffect(() => {
    callbackRef.current = onResize;
  }, [onResize]);

  useLayoutEffect(() => {
    const element = target.current;
    if (!element) {
      return;
    }

    let frame: number | undefined;
    const observer = new ResizeObserver(([entry]) => {
      if (!entry) {
        return;
      }
      if (frame !== undefined) {
        cancelAnimationFrame(frame);
      }
      frame = requestAnimationFrame(() => {
        callbackRef.current(entry);
      });
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
      if (frame !== undefined) {
        cancelAnimationFrame(frame);
      }
    };
  }, [target]);
};
